import { render } from "./Items.vue?vue&type=template&id=f914b3fe&scoped=true"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"

import "./Items.vue?vue&type=style&index=0&id=f914b3fe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f914b3fe"]])

export default __exports__